import { render, staticRenderFns } from "./BatchEditConfirmation.vue?vue&type=template&id=272d449c"
import script from "./BatchEditConfirmation.vue?vue&type=script&lang=js"
export * from "./BatchEditConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports